import { useEffect, useState, type ReactNode } from 'react'

import { applyTheme, readThemeChoice, storeThemeChoice, type ThemeChoice } from '../theme.js'

/*
 * Label sependek mungkin: kontrol ini duduk di bilah atas bersama sepuluh
 * tautan menu, dan "Ikuti sistem" saja sudah cukup melebarkannya hingga bilah
 * itu membungkus ke baris kedua. Nama yang dibaca pembaca layar tetap utuh
 * lewat `aria-label`.
 */
const LABEL: Record<ThemeChoice, string> = {
  sistem: 'Sistem',
  terang: 'Terang',
  gelap: 'Gelap',
}

/**
 * Pemilih tema.
 *
 * Dibaca sekali saat komponen lahir, bukan diangkat ke context: temanya tinggal
 * pada atribut elemen akar dan CSS yang membacanya, sehingga tidak ada bagian
 * lain aplikasi yang perlu tahu nilainya. State di sini hanya menjaga tampilan
 * kontrolnya sendiri tetap sesuai.
 */
export function PilihTema(): ReactNode {
  const [pilihan, setPilihan] = useState<ThemeChoice>(() => readThemeChoice())

  // Skrip di `index.html` sudah memasangnya sebelum gaya dilukis; ini menjaga
  // keduanya tetap sejalan bila pilihannya berubah di tab yang sama.
  useEffect(() => {
    applyTheme(pilihan)
  }, [pilihan])

  return (
    <label className="inline-label pilih-tema">
      <span className="pilih-tema-ikon" aria-hidden="true">
        ◐
      </span>
      <span className="visually-hidden">Tema tampilan</span>
      <select
        value={pilihan}
        aria-label="Tema tampilan"
        onChange={(e) => {
          const nilai = e.target.value as ThemeChoice
          setPilihan(nilai)
          storeThemeChoice(nilai)
        }}
      >
        {(Object.keys(LABEL) as ThemeChoice[]).map((k) => (
          <option key={k} value={k}>
            {LABEL[k]}
          </option>
        ))}
      </select>
    </label>
  )
}
